import type { IMeterTypeIconProps } from './helpers';

export const MeterTypeIcon = ({ selected, ...rest }: IMeterTypeIconProps) =>
	selected ? (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
			className={`${rest.className} svg-dark`}
		>
			<rect
				x='0.5'
				y='0.5'
				width='15'
				height='15'
				rx='7.5'
				fill='#05A2BF'
			/>
			<rect
				x='0.5'
				y='0.5'
				width='15'
				height='15'
				rx='7.5'
				stroke='white'
			/>
			<circle
				cx='8.00029'
				cy='7.99883'
				r='3.2'
				fill='white'
			/>
		</svg>
	) : (
		<svg
			width='17'
			height='16'
			viewBox='0 0 17 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
			className={`${rest.className} svg-dark svg-dark-outline`}
		>
			<rect
				x='1'
				y='0.5'
				width='15'
				height='15'
				rx='7.5'
				fill='#F2F3F3'
			/>
			<rect
				x='1'
				y='0.5'
				width='15'
				height='15'
				rx='7.5'
				stroke='#ECEEEE'
			/>
			<circle
				cx='8.50029'
				cy='7.99883'
				r='3.2'
				fill='#DFE2E2'
			/>
		</svg>
	);
